exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".index__iframe___1maqU{border:none;width:100%;height:calc(100vh - 70px)}", "", {"version":3,"sources":["/./src/routes/OfferMaster/src/routes/OfferMaster/containers/index.scss"],"names":[],"mappings":"AACA,uBACE,YAAY,WACD,yBACe,CAC3B","file":"index.scss","sourcesContent":["\n.iframe {\n  border: none;\n  width: 100%;\n  height: calc(100vh - 70px);\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"iframe": "index__iframe___1maqU"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap&modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./~/sass-loader?sourceMap!./src/routes/OfferMaster/containers/index.scss
// module id = 1610
// module chunks = 0